import { getInitialState, getPath } from "../../utils";

const initialState = {
  configs: [],
  keys: [],
  namespaces: [],
  activeHierarchyFiltersConfig: {},
  prevPage: -1,
  nextPage: 2,
  currentNamespace: "",
  currentKey: "",
  userData: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_FEATURE_CONFIGS":
      return setConfigs(state, action);
    case "SET_FEATURE_CONFIG_KEYS":
      return setKeys(state, action);
    case "SET_FEATURE_CONFIG_NAMESPACES":
      return setNamespaces(state, action);
    case "RESET_STATE_FEATURE_CONFIG":
      return resetStateFeatureConfig(state, action);
    case "SET_ACTIVE_HIERARCHY_FILTERS_CONFIG":
      return setActiveHierarchyFiltersConfig(state, action);
    case "SET_FEATURE_CONFIG_CURRENT_NAMESPACE":
      return setCurrentNamespace(state, action);
    case "SET_FEATURE_CONFIG_CURRENT_KEY":
      return setCurrentKey(state, action);
    case "SET_FEATURE_CONFIG_PREV_PAGE":
      return setPrevPage(state, action);
    case "SET_FEATURE_CONFIG_NEXT_PAGE":
      return setNextPage(state, action);
    case "SET_FEATURE_CONFIG_USER_DATA":
      return setUserData(state, action);  
    default:
      return state;
  }
}

const setConfigs = (state, action) => {
  return {
    ...state,
    configs: action.payload,
  };
};

const setKeys = (state, action) => {
  return {
    ...state,
    keys: action.payload,
  };
};

const setNamespaces = (state, action) => {
  return {
    ...state,
    namespaces: action.payload,
  };
};

const resetStateFeatureConfig = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveHierarchyFiltersConfig = (state, action) => {
  return {
    ...state,
    activeHierarchyFiltersConfig: action.payload,
  };
};

const setCurrentNamespace = (state, action) => {
  return {
    ...state,
    currentNamespace: action.payload,
  };
};

const setCurrentKey = (state, action) => {
  return {
    ...state,
    currentKey: action.payload,
  };
};

const setPrevPage = (state, action) => {
  return {
    ...state,
    prevPage: action.payload,
  };
};

const setNextPage = (state, action) => {
  return {
    ...state,
    nextPage: action.payload,
  };
};

const setUserData = (state, action) => {
  return {
    ...state,
    userData: action.payload
  }
}
